import { readonly, shallowRef } from "vue";

import { runs as runsApi } from "~/api";

/**
 * Composable for fetching a single run's detail (including log entries) as JSON.
 *
 * @param {string} runId
 * @returns {{
 *   run: import('vue').DeepReadonly<import('vue').ShallowRef<object|null>>,
 *   loading: import('vue').DeepReadonly<import('vue').ShallowRef<boolean>>,
 *   error: import('vue').DeepReadonly<import('vue').ShallowRef<string|null>>,
 *   fetchRun: Function,
 *   clearError: Function
 * }}
 */
export function useRun(runId) {
  const _run = shallowRef(null);
  const _loading = shallowRef(false);
  const _error = shallowRef(null);

  async function fetchRun() {
    _loading.value = true;
    _error.value = null;

    try {
      _run.value = await runsApi.show({ params: { id: runId } });
    } catch (err) {
      _error.value = err.message || "Oops, something went wrong!";
    } finally {
      _loading.value = false;
    }
  }

  function clearError() {
    _error.value = null;
  }

  return {
    clearError,
    error: readonly(_error),
    fetchRun,
    loading: readonly(_loading),
    run: readonly(_run)
  };
}
